import 'vuetify/dist/vuetify.min.css';

import Vue from 'vue';
import Vuetify from 'vuetify/lib';

Vue.use(Vuetify, {
  options: {
    customProperties: true,
  },
});

const options = {
  icons: {
    iconfont: 'md',
  },
  theme: {
    options: {
      customProperties: true,
    },
    dark: false,
    themes: {
      light: {
        primary: '#01579B',
        secondary: '#012a4e',
        info: '#e5edf7',
        accent: {
          base: '#f8d612',
          lighten1: '#fae361',
        },
        error: '#ef5350',
        warning: '#ee862b',
        success: {
          base: '#39c844',
          lighten1: '#89e75f',
          lighten2: '#b5e89d',
          darken1: '#67ae28',
          darken2: '#589622',
        },
      },
    },
  },
};

export default new Vuetify(options);
export { options };
